var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlaySmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4429_16499)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5195 7.64636L5.52148 2.14733C5.36992 2.05465 5.1964 2.00403 5.01878 2.00067C4.84116 1.99731 4.66585 2.04133 4.51089 2.12821C4.35593 2.21509 4.22692 2.34168 4.13712 2.49497C4.04733 2.64826 4 2.82271 4 3.00036V13.9994C4.00014 14.177 4.04757 14.3513 4.13739 14.5045C4.22722 14.6577 4.35622 14.7843 4.51113 14.8711C4.66604 14.958 4.84128 15.002 5.01884 14.9987C5.19641 14.9954 5.3699 14.9449 5.52148 14.8524L14.5195 9.35339C14.6657 9.264 14.7865 9.13858 14.8703 8.98913C14.954 8.83967 14.998 8.67121 14.998 8.49987C14.998 8.32854 14.954 8.16007 14.8703 8.01062C14.7865 7.86117 14.6657 7.73574 14.5195 7.64636V7.64636Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4429_16499"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaySmall);
export default __webpack_public_path__ + "static/media/play-small.c54186d94353402c79396bfb197b7f80.svg";
export { ForwardRef as ReactComponent };